// extracted by mini-css-extract-plugin
module.exports = {"heading":"PrivacyPolicyPage_heading__34Oym","content":"PrivacyPolicyPage_content__25kfZ"};